import { useEffect } from 'react';
import { AppState, Platform } from 'react-native';
import { ensureFreshAccessToken } from '../../shared/supabase/supabaseClient';
import { captureCatch } from '../../shared/sentry/sentryUser';

/**
 * Al volver a primer plano (app o pestaña web), renueva el JWT antes de que disparen RPC en paralelo.
 */
export function useSupabaseSessionKeepAlive(enabled: boolean) {
  useEffect(() => {
    if (!enabled) return;

    const refresh = () => {
      void ensureFreshAccessToken().catch(captureCatch('auth', 'keepalive-token-refresh'));
    };

    const appSub = AppState.addEventListener('change', (state) => {
      if (state === 'active') refresh();
    });

    let removeVisibility: (() => void) | undefined;
    if (Platform.OS === 'web' && typeof document !== 'undefined') {
      const onVisibility = () => {
        if (document.visibilityState === 'visible') refresh();
      };
      document.addEventListener('visibilitychange', onVisibility);
      removeVisibility = () => document.removeEventListener('visibilitychange', onVisibility);
    }

    return () => {
      appSub.remove();
      removeVisibility?.();
    };
  }, [enabled]);
}
